"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toIcalendarDateFormat = exports.toDateTime = exports.isValidFutureDate = exports.isDateInTheFuture = exports.getYear = exports.getTimeOfDayWithSeparator = exports.getTimeOfDay = exports.getNameOfWeekDay = exports.getNameOfMonth = exports.getDayOfMonth = exports.compareDatesAscNullsLast = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var isValidFutureDate = function isValidFutureDate(dateMoment) {
  return dateMoment && dateMoment.isValid() && isDateInTheFuture(dateMoment);
};
exports.isValidFutureDate = isValidFutureDate;
var isDateInTheFuture = function isDateInTheFuture(dateMoment) {
  return (0, _moment["default"])().diff(dateMoment) < 0;
};
exports.isDateInTheFuture = isDateInTheFuture;
var compareDatesAscNullsLast = function compareDatesAscNullsLast(dateMomentA, dateMomentB) {
  if (!dateMomentA && dateMomentB) return 1;
  if (dateMomentA && !dateMomentB) return -1;
  if (!dateMomentA && !dateMomentB) return 0;
  return compareValues(dateMomentA.valueOf(), dateMomentB.valueOf());
};
exports.compareDatesAscNullsLast = compareDatesAscNullsLast;
var compareValues = function compareValues(a, b) {
  if (a === b) return 0;
  if (a > b) {
    return 1;
  }
  return b > a ? -1 : 0;
};
var toDateTime = function toDateTime(dateMoment, timeOfDay) {
  if (!dateMoment || !timeOfDay) return null;
  var time = timeOfDay.split(':');
  return (0, _moment["default"])(dateMoment).set({
    hour: time[0],
    minute: time[1]
  });
};
exports.toDateTime = toDateTime;
var toIcalendarDateFormat = function toIcalendarDateFormat(dateMoment) {
  return "".concat(dateMoment.utc().format('YYYYMMDDTHHmmss[Z]'));
};
exports.toIcalendarDateFormat = toIcalendarDateFormat;
var getNameOfMonth = function getNameOfMonth(dateMoment) {
  return dateMoment.locale('no').format('MMMM');
};
exports.getNameOfMonth = getNameOfMonth;
var getDayOfMonth = function getDayOfMonth(dateMoment) {
  return dateMoment.format('D');
};
exports.getDayOfMonth = getDayOfMonth;
var getYear = function getYear(dateMoment) {
  return dateMoment.format('YYYY');
};
exports.getYear = getYear;
var getNameOfWeekDay = function getNameOfWeekDay(dateMoment) {
  return dateMoment.locale('no').format('dddd');
};
exports.getNameOfWeekDay = getNameOfWeekDay;
var getTimeOfDayWithSeparator = function getTimeOfDayWithSeparator(dateMoment, separator) {
  return dateMoment.local().format("HH".concat(separator, "mm"));
};
exports.getTimeOfDayWithSeparator = getTimeOfDayWithSeparator;
var getTimeOfDay = function getTimeOfDay(dateMoment) {
  return getTimeOfDayWithSeparator(dateMoment, '.');
};
exports.getTimeOfDay = getTimeOfDay;